import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search, MoreVertical, Music, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { mockArtists } from '@/lib/mockData';
import { formatDate } from '@/lib/utils';

export function AdminArtistsList() {
  return (
    <AdminLayout>
      <div className="p-8">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-white">Artists</h1>
            <p className="text-muted-foreground mt-1">{mockArtists.length} total artists</p>
          </div>
          <Link to="/admin/artists/new">
            <Button className="bg-primary text-primary-foreground hover:bg-primary/90">
              <Plus className="w-4 h-4 mr-2" />
              Add New Artist
            </Button>
          </Link>
        </div>

        {/* Search */}
        <div className="mb-6">
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input 
              placeholder="Search" 
              className="bg-card border-border pl-10"
            />
          </div>
        </div>

        {/* Artists Table */}
        <Card className="bg-card border-border overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left p-4 text-muted-foreground font-medium">Name</th>
                  <th className="text-left p-4 text-muted-foreground font-medium">Instrument / Speciality</th>
                  <th className="text-left p-4 text-muted-foreground font-medium">Total Performances</th>
                  <th className="text-left p-4 text-muted-foreground font-medium">Last Event Performed</th>
                  <th className="p-4"></th>
                </tr>
              </thead>
              <tbody>
                {mockArtists.map(artist => (
                  <tr key={artist.id} className="border-b border-border hover:bg-secondary/50 transition-colors">
                    <td className="p-4">
                      <Link to={`/admin/artists/${artist.id}`} className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                        <div className="w-10 h-10 rounded-full overflow-hidden">
                          <img 
                            src={artist.image} 
                            alt={artist.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="font-medium text-white hover:text-primary transition-colors">{artist.name}</span>
                      </Link>
                    </td>
                    <td className="p-4">
                      <span className="flex items-center gap-2 text-muted-foreground">
                        <Music className="w-4 h-4" />
                        {artist.instrument}
                      </span>
                    </td>
                    <td className="p-4 text-white">{artist.totalPerformances}</td>
                    <td className="p-4 text-muted-foreground">{formatDate(artist.lastEvent)}</td>
                    <td className="p-4">
                      <Link to={`/admin/artists/${artist.id}`}>
                        <button className="p-2 hover:bg-secondary rounded-lg">
                          <ChevronRight className="w-4 h-4 text-muted-foreground" />
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}

export default AdminArtistsList;
